import DOMPurify from "dompurify";
import { marked, type Links, type Token } from "marked";
import { useMemo } from "react";

/** Repo content is written by agents: every path from markdown to HTML goes through DOMPurify. */
export const sanitize = (html: string) => DOMPurify.sanitize(html);

/** Renders some top-level tokens of a document; `links` keeps its reference-style links resolving. */
export function tokensToHtml(tokens: Token[], links: Links = {}) {
  return sanitize(marked.parser(Object.assign([...tokens], { links })));
}

export function Markdown({ source }: { source: string }) {
  const html = useMemo(() => sanitize(marked.parse(source, { async: false }) as string), [source]);
  return <div className="markup" dangerouslySetInnerHTML={{ __html: html }} />;
}
